import CatalogGrid from './CatalogGrid';

export default CatalogGrid;
